import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './app/app';
import { cacheRtl, theme } from './theme/theme';
import { AppContextProvider } from './context/AppContext';
import { ToastProvider } from './components/common/toast';
import { BusyProvider } from './components/common/busy';
import { FeedbackProvider } from './components/common/feedback';
import { queryClient } from './react-query';

import './main.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <CacheProvider value={cacheRtl}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppContextProvider>
              <ToastProvider>
                <BusyProvider>
                  {/* "פנייה חדשה" from anywhere — the floating button and the screen's own buttons. */}
                  <FeedbackProvider>
                    <App />
                  </FeedbackProvider>
                </BusyProvider>
              </ToastProvider>
            </AppContextProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </CacheProvider>
    </BrowserRouter>
  </StrictMode>
);
